import React from 'react';
import styles from './shButton.module.scss';

import PropTypes from 'prop-types';
// React.forwardRef(({ onClick, href }, ref) => {
const ShButton =  ({ children,
                    variant,
                    disabled = false,
                    className = '',
                    size = 'large',
                    onClick = () => { }
                  }) => {
    return <button onClick={onClick} className={`${className} ${styles.button} ${styles[variant]} ${size === 'small' ? styles.small : styles.large}`}>
        { disabled && <div className={styles.disabledOverlay} /> }
        {children}
    </button>
};

export default ShButton;

ShButton.propTypes = {
    variant: PropTypes.oneOf(
        [ 'empty', 'primary', 'outline', 'dark', 'solid-dark', 'solid-dark-with-opacity', 'solid-dark-outline', 'white', 'white-outline', 'green', 'green-outline' ]
    ).isRequired,
    size: PropTypes.oneOf(
        [ 'large', 'small']
    )
}
